'use client';

import { Suspense } from 'react';

import { HeaderFilters } from '@/components/search/filters/header-filters';
import { SearchForm } from '@/components/search/search-form';
import { Skeleton } from '@/components/ui/skeleton';

export default function SearchSection() {
  return (
    <div className='flex w-full items-center justify-start lg:justify-center'>
      <Suspense
        fallback={
          <Skeleton className='h-10 w-full max-w-56 sm:max-w-80 lg:max-w-96' />
        }
      >
        <SearchForm
          placeholder='Search for skills...'
          className='w-full max-w-56 sm:max-w-80 lg:max-w-96'
          filtersButton={
            <Suspense fallback={<Skeleton className='size-8' />}>
              <HeaderFilters />
            </Suspense>
          }
        />
      </Suspense>
    </div>
  );
}
